import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/ThemeToggle.scss';

export const ThemeToggle = () => {
  const [isDarkTheme, setIsDarkTheme] = useState(false);
  const location = useLocation();
  
  // Check if we're on the landing page
  const isLandingPage = location.pathname === '/';

  // Initialize theme from localStorage or system preference
  useEffect(() => {
    if (isLandingPage) {
      // Force dark mode on landing page
      setIsDarkTheme(false);
      document.body.className = 'light-theme';
      return;
    }

    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      setIsDarkTheme(savedTheme === 'dark');
      document.body.className = savedTheme + '-theme';
    } else {
      // Check system preference
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      setIsDarkTheme(prefersDark);
      document.body.className = prefersDark ? 'dark-theme' : 'light-theme';
    }
  }, [isLandingPage]);

  // Toggle theme
  const toggleTheme = () => {
    if (isLandingPage) return; // Don't allow theme toggle on landing page
    
    const newTheme = isDarkTheme ? 'light' : 'dark';
    setIsDarkTheme(!isDarkTheme);
    document.body.className = newTheme + '-theme';
    localStorage.setItem('theme', newTheme);
  };

  // Don't render the toggle on the landing page
  if (isLandingPage) {
    return null;
  }

  return (
    <button 
      onClick={toggleTheme}
      className="theme-toggle"
      aria-label={isDarkTheme ? 'Switch to light theme' : 'Switch to dark theme'}
    >
      {isDarkTheme ? (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clipRule="evenodd" />
        </svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
        </svg>
      )}
    </button>
  );
}; 